module.exports = __webpack_public_path__ + "img/red_dot_fitness.4a5df326.png";